// extracted by mini-css-extract-plugin
export default {"root":"ReviewDrawer_root__TnKVd","body":"ReviewDrawer_body__jJBQL","spin":"ReviewDrawer_spin__n3ZtP"};